import React, { useState, useEffect, createContext } from "react";

// api services
import { FastestFingerService } from "../services";

const FastestFingerContext = createContext({});

const Provider = ({ children }) => {
  const [fastestFingerData, setFastestFingerData] = useState();
  const [gameStatus, setGameStatus] = useState();

  return (
    <FastestFingerContext.Provider
      value={{
        getFastestFinger,
        fastestFingerData,
        startGame,
        getGameStatus,
        gameStatus,
        setFastestFingerData,
      }}
    >
      {children}
    </FastestFingerContext.Provider>
  );

  async function getFastestFinger() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const resp = await FastestFingerService.getFastestFinger(token);
      const { success, data } = resp;
      if (success) {
        setFastestFingerData(data);
      }
    } catch (e) {
      console.log(e);
    } finally {
    }
  }

  async function startGame() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      await FastestFingerService.startGame(token);
    } catch (e) {
      console.log(e);
    } finally {
    }
  }

  async function getGameStatus() {
    try {
      const token = JSON.parse(localStorage.getItem("token"));
      const data = await FastestFingerService.getGameStatus(token);
      if (data) {
        setGameStatus(data);
      }
    } catch (e) {
      console.log(e);
    } finally {
    }
  }
};

FastestFingerContext.ProviderWrapper = Provider;

export default FastestFingerContext;
